import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "energiness",
  favicon: "/energiness-favicon.png",
  companyName: "Energiness",
  website: 'https://www.energiness.club/',
  notifyChannel: 'vel-energiness',
  onlyOneClub: true,
  htmlCustomCSS: "energiness.scss",
  header: {
    title: "",
    logo: "/energiness-logo2.png",
  },
  plans: {
    ...configDefault.plans,
    withBanner: true,
  },
  navigation: {
    ...configDefault.navigation,
    display: "line"
  },
  steps: {
    ...configDefault.steps,
    display: {
      showShortNames: false,
    },
    userForm: {
      ...configDefault.steps.userForm,
      displayFirstOffer: false,
    }
  },
  footer: {
    ...configDefault.footer,
    logo: null,
    textLine: "",
    cgv: {
      link: "https://www.energiness.club/r%C3%A9glement-int%C3%A9rieur-cgv",
      text: "Mentions légales et CGV",
    },
  },
};

export default config;
